export default function AttachFileIcon({ width = 12, height = 16, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='-0.5 -0.5 11.27 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        d='M3.733 4.667V8.4a1.867 1.867 0 003.734 0V3.733a3.733 3.733 0 00-7.467 0v5.134a5.133 5.133 0 0010.267 0V3.733'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
